import axios from 'axios'

export default {
  name: 'ajax-call',

  events: [
    {
      on: 'click',
      handle () {
        axios.delete(this.props.url)
          .then(response => {
            if (response.data.success) {
              const successMessage = document.createElement('p')
              successMessage.className = 'form__success'
              successMessage.innerHTML = this.props.success

              this.el.parentNode.parentNode.append(successMessage)

              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          })
          .catch(e => {
            if (e.response) {
              const errorWrap = document.createElement('div')
              errorWrap.classList.add('mt-4')
              const error = document.createElement('div')
              error.classList.add('form__error-big')
              error.setAttribute('js-form-error', '')
              error.innerHTML = e.response.data && e.response.data.message ? e.response.data.message : 'Erreur lors de la soumission'

              errorWrap.append(error)

              this.el.parentNode.parentNode.append(errorWrap)
            }
          })
      },
    },
  ],

  componentDidMount () {

  },
}
